import React from 'react';
import {Box, Button, ModalContent, ModalContentText} from "@deere/fuel-react";
import DeleteIcon from "@material-ui/icons/Delete";

export const CampaignModalContent = ({content}) => {
    return (
        <ModalContent dividers>
            <Box display="flex" alignItems="center">
                <Box>
                    <ModalContentText id="alert-Modal-description">
                        {content}
                    </ModalContentText>
                </Box>
            </Box>
        </ModalContent>
    );
};

export const CampaignModalButton = ({handleClickOpen}) => {
    return (
        <Button variant="text" style={{marginRight: "1rem"}} onClick={handleClickOpen}><DeleteIcon/>&nbsp; Delete</Button>
    );
};



